/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { Room } from '../../../interfaces/masters/room';

@Injectable()
export class RoomApi {
  private readonly apiController: string = 'room';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    //header.append('Content-Type', 'applications/json');
    //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    //header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  getById(url : string, options?: any): Observable<Room> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: Room):Observable<Room[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    // const formData: FormData = new FormData();
    // formData.append('Image', data.photo);
    // data.photo = formData;
    return this.api.post( url, data, header); 
  }
 
  update(url:string, data: Room):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    // const formData: FormData = new FormData();
    // formData.append('Image', data.photo);
    // data.photo = formData;
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
